//export default {
//  path: '/statistics',
//  name: 'Statistics',
//  redirect: '/statistics/list',
//  component: () => import('@/components/layout'),
//  meta: { requiresAuth: false },
//  children: [
//    {
//      path: 'list',
//      component: () => import('@/views/statistics'),
//      meta: { requiresAuth: false }
//    },
//  ]
//}
const displayRoutes = [
  {
    path: '/statistics',
    name: 'Statistics',
    component: () => import('@/views/statistics'),
    meta: {requiresAuth: false},
  },
  {
    path: '/statisticsYouth',
    name: 'StatisticsYouth',
    component: () => import('@/views/statistics/youthIndex'),
    meta: {requiresAuth: false},
  },
  {
    path: '/statisticsSchool',
    name: 'StatisticsSchool',
    component: () => import('@/views/statistics/statisticsSchool'),
    meta: {requiresAuth: false},
  },
  {
    path: '/statisticsOrganizational',
    name: 'StatisticsOrganizational',
    component: () => import('@/views/statistics/statisticsOrganizational'),
    meta: {requiresAuth: false},
  },
  {
    path: '/statisticsSiteFacilities',
    name: 'StatisticsSiteFacilities',
    component: () => import('@/views/statistics/statisticsSiteFacilities'),
    meta: {requiresAuth: false},
  },
  {
    path: '/statisticsKeyCityTrain',
    name: 'StatisticsKeyCityTrain',
    component: () => import('@/views/statistics/keyCityTrain'),
    meta: {requiresAuth: false},
  }
];

export  default displayRoutes;
